import {Route} from "vue-router";
import store from "@/config/store";
import {getRootCategoryFromPath} from "@/utils/Categories";
import {shift} from "@/utils/Paths";

export function updateHreflangTags(route: Route) {
    document.querySelectorAll('head link[data-ork-dynamic-hreflang]')
        .forEach(el => document.head.removeChild(el));
    document.querySelectorAll('head link[data-ork-dynamic-canonical]')
        .forEach(el => document.head.removeChild(el));

    const availableCatalogs = store.getters.getRootCategories;
    const currentCatalog = getRootCategoryFromPath(`${route.params.catalog}/`, availableCatalogs);
    const query = route.fullPath.substring(route.path.length);

    if (!currentCatalog?.alternates?.length) {
        return;
    }

    const alternates = [currentCatalog.path, ...currentCatalog.alternates];
    for (const alternate of alternates) {
        const alternateCatalog = getRootCategoryFromPath(alternate, availableCatalogs);

        if (!alternateCatalog) {
            continue;
        }

        const isoLanguage = route.params.locale.toLowerCase();
        const isoCountry = alternateCatalog.countryCode.toUpperCase();
        const path = shift(route.path, 2);
        const cleanedAlternate = alternate.substring(0, alternate.indexOf("/"));

        if (alternateCatalog.xDefault) {
            const hreflangTag = document.createElement("link");
            hreflangTag.setAttribute("rel", "alternate");
            hreflangTag.setAttribute("hreflang", 'x-default');
            hreflangTag.setAttribute(
              "href",
              `${process.env.VUE_APP_HTTP_VERSION}://${process.env.VUE_APP_HOST}/${cleanedAlternate}/${isoLanguage}${path}${query}`
            );
            hreflangTag.setAttribute("data-ork-dynamic-hreflang", '');

            document.head.appendChild(hreflangTag);
        }

        const hreflangTag = document.createElement("link");
        hreflangTag.setAttribute("rel", "alternate");
        hreflangTag.setAttribute("hreflang", `${isoLanguage}-${isoCountry}`);
        hreflangTag.setAttribute(
            "href",
            `${process.env.VUE_APP_HTTP_VERSION}://${process.env.VUE_APP_HOST}/${cleanedAlternate}/${isoLanguage}${path}${query}`
        );
        hreflangTag.setAttribute("data-ork-dynamic-hreflang", '');

        document.head.appendChild(hreflangTag);

        if (alternate === currentCatalog.path) {
            const canonicalTag = document.createElement("link");
            canonicalTag.setAttribute("rel", "canonical");
            canonicalTag.setAttribute(
              "href",
              `${process.env.VUE_APP_HTTP_VERSION}://${process.env.VUE_APP_HOST}/${cleanedAlternate}/${isoLanguage}${path}${query}`
            );
            canonicalTag.setAttribute("data-ork-dynamic-canonical", '');

            document.head.appendChild(canonicalTag);
        }
    }
}